import Vue from 'vue';
import Vuex from 'vuex';
import { settings } from '@/store/settings';
import { analytics } from '@/store/analytics/analytics';
import { account } from '@/store/account/account';
import { activeItem } from '@/store/activeItem/';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);
const store = {
  
  strict: true,
  state: {
    version: '1.0.0',
  },
  modules: {
    settings,
    account,
    activeItem,
    analytics,
  },
  plugins: [
    createPersistedState({
      key: 'kidjo-webapp',
      paths: ['account.subscriberId', 'account.operationId', 'analytics.media'],
    })
  ],
};

export default new Vuex.Store(store);
